import React, { useState, useEffect } from "react";
import { ArchiveBoxIcon } from "@heroicons/react/24/outline";
import CustomShoppngCardDetials from "./customShoppingCardData";
import CustomShoppingCard from "./customShoppingCrad";
import imageTrukey from "../../assets/images/truckeyShoppingImage.webp";
import imageFlag from "../../assets/images/turkey.webp";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import CustomLines from "./customLines";
import CustomBigText from "../sharedComponents/customBigText";
import BoxSection2 from "../../assets/images/BoxSection2.webp";
import CustomTitle from "../sharedComponents/customTitle";

const ShoppingTrukeySection = () => {
  // const  navigate = useNavigate();
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();

  const handleClick = () => {
    navigateWithLang("/category-turkey");
  };
  return (
    <div className="relative" dir={direction}>
      <img
        src={BoxSection2}
        loading="lazy"
        alt="Background"
        className="absolute top-0 left-0 hidden w-14 md:w-20 md:block"
      />
      <div className="pb-10 max-container">
        <div>
          {/* <CustomLines />
              <CustomBigText
              title={t('shoppingTurkeySection.title')}
              /> */}
          <div>
            <CustomTitle title={t("shoppingTurkeySection.title")} />
          </div>
          <div className="flex flex-col-reverse px-4 pt-5 mt-4 md:px-0 md:flex-row md:mt-0">
            <CustomShoppngCardDetials
              title={t("shoppingTurkeySection.cardTitle2")}
              image={imageFlag}
              icon={ArchiveBoxIcon}
              onClick={handleClick}
              imageTitle={t("shoppingTurkeySection.flagImageTitle")}
              children={t("shoppingTurkeySection.buttonLabel")}
              subTitle={t("shoppingTurkeySection.cardSubtitle2")}
              area="67dfef4a100f542a2c700c04"
            />

            <CustomShoppingCard
              image={imageTrukey}
              title={t("shoppingTurkeySection.cardTitle1")}
              subTitle={t("shoppingTurkeySection.cardSubtitle1")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingTrukeySection;
